/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IShowCustomerRefInfoInput {
    canEdit: boolean;
    customerRef: string;
    resources: {
        customerRefLabel: string;
        editBtnLabel: string;
        customerRefErrortext: string;
    };
    onEdit(): void;
}

export interface IShowCustomerRefInfo {
    showInfoProps: INodeProps;
    customerRef: React.ReactNode;
    label: React.ReactNode;
}

const getCustomerRefInfo = ({
    canEdit,
    customerRef,
    resources: { customerRefLabel, editBtnLabel, customerRefErrortext },
    onEdit
}: IShowCustomerRefInfoInput): IShowCustomerRefInfo => ({
    label: (
        <label id='ms-checkout-guest-profile__label' className='ms-checkout-guest-profile__input-label'>
            {customerRefLabel}
        </label>
    ),
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    customerRef: (
        <span className='ms-checkout-guest-profile__selected-email'>{customerRef === '' ? customerRefErrortext : customerRef}</span>
    )
});

export default getCustomerRefInfo;
